module.exports = __webpack_public_path__ + "img/1352868789.50da5f96.jpg";